// src/App.js
import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import GameCard from '../../components/GameCard/GameCard'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Data from '../data.json'
import PremiumGames from '../Games/PremiumGames';
import BlogCard from '../../components/BlogCard/BlogCard';
import AdCMP from '../../components/ADS/AdCMP';

const Home = () => {
    const { gamesList } = useDarkMode();
    return (
        <React.Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport"
                    content="width=device-width, initial-scale=1.0, minimal-ui, shrink-to-fit=no, viewport-fit=cover" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                <meta name="apple-mobile-web-app-title" content="VibeOfGames" />
                <meta name="HandheldFriendly" content="true" />
                <meta name="mobile-web-app-capable" content="yes" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <link rel="icon" href="/favicon.ico" />
                <link rel="apple-touch-icon" href="/logo.png" />
                <link rel="manifest" href="/manifest.json" />

                <title>Play Free Online Games | VibeOfGames - Best Browser Games</title>
                <meta name="title" content="Play Free Online Games | VibeOfGames - Best Browser Games" />
                <meta name="description"
                    content="Play the best free online games at VibeOfGames! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta name="keywords"
                    content="free online games, play games online, VibeOfGames, best games, arcade games, action games, puzzle games, browser games, instant play" />

                <meta property="og:title" content="Play Free Online Games | VibeOfGames - Best Browser Games" />
                <meta property="og:description"
                    content="Play the best free online games at VibeOfGames! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta property="og:url" content="https://vibeofgames.com/" />
                <meta property="og:site_name" content="VibeOfGames" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://vibeofgames.com/logo.png" />
                <meta property="og:locale" content="en" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Play Free Online Games | VibeOfGames - Best Browser Games" />
                <meta name="twitter:description"
                    content="Play the best free online games at VibeOfGames! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta name="twitter:image" content="https://vibeofgames.com/logo.png" />

                <meta name="robots" content="index, follow" />
                <meta name="geo.region" content="US" />
                <meta name="geo.placename" content="North America" />
                <meta name="geo.position" content="37.0902;-95.7129" />
                <meta name="ICBM" content="37.0902, -95.7129" />
                <link rel="canonical" href="https://vibeofgames.com/" />
            </Helmet>

            {/* Hero Ad */}
            <div className="mt-14">
                <div className='hidden xl:block'>
                    <AdCMP adSize='728x90' dataAdSlot="6784508920" />
                </div>
                <div className='hidden md:block xl:hidden'>
                    <AdCMP adSize='468x60' dataAdSlot="6784508920" />
                </div>
                <div className='block md:hidden'>
                    <AdCMP adSize='320x50' dataAdSlot="6784508920" />
                </div>
            </div>

            <div className="p-2 sm:p-4 sm:ml-56">
                {/* Top Picks Section */}
                <div className="mt-2">
                    <div className='flex justify-between items-center mb-6'>
                        <h2 className='text-black dark:text-white font-bold text-base sm:text-lg lg:text-xl flex items-center'>
                            <span className='text-xl sm:text-3xl mr-2 sm:mr-3'>🔥</span>
                            <span className='bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent'>Top picks for you</span>
                        </h2>
                        <Link to="/category/all-games" className='group touch-manipulation'>
                            <div className='bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-2 sm:px-5 sm:py-3 rounded-xl font-medium text-sm sm:text-lg hover:from-orange-400 hover:to-red-400 transition-all duration-300 flex items-center'>
                                <span>View All</span>
                                <svg className='w-3 h-3 sm:w-4 sm:h-4 ml-1 sm:ml-2 transform group-hover:translate-x-1 transition-transform duration-300' fill='currentColor' viewBox='0 0 20 20'>
                                    <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                                </svg>
                            </div>
                        </Link>
                    </div>

                    {/* Featured Game Carousel */}
                    <div className="mb-8">
                        <div className="bg-gradient-to-r from-orange-100 to-red-100 dark:from-orange-900/20 dark:to-red-900/20 rounded-2xl p-6 border border-orange-200 dark:border-orange-700">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                <div className="lg:col-span-2">
                                    {gamesList && gamesList[0] && (
                                        <Link to={`/game/${gamesList[0]?.name?.en?.toLowerCase().replace(/\s+/g, "-")}`} className="block">
                                            <div className="relative group cursor-pointer" >
                                                <img
                                                    src={gamesList[0]?.assets?.cover || gamesList[0]?.assets?.square}
                                                    alt={gamesList[0]?.name?.en}
                                                    className="w-full h-48 sm:h-64 object-cover rounded-xl group-hover:scale-105 transition-transform duration-300"
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                <div className="absolute bottom-4 left-4 text-white">
                                                    <h3 className="text-xl font-bold mb-2">{gamesList[0]?.name?.en}</h3>
                                                    <div className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium inline-block">
                                                        {gamesList[0]?.categories?.en}
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                                <div className="space-y-4">
                                    {gamesList?.slice(1, 4)?.map((_ele, i) => {
                                        const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                                        return (
                                            <Link key={i} to={`/game/${GetSlug}`} className="block group">
                                                <div className="flex items-center space-x-3 p-3 bg-white dark:bg-gray-800 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-300">
                                                    <img
                                                        src={_ele?.assets?.square}
                                                        alt={_ele?.name?.en}
                                                        className="w-12 h-12 object-cover rounded-lg group-hover:scale-110 transition-transform duration-300"
                                                    />
                                                    <div className="flex-1">
                                                        <h4 className="font-medium text-base text-gray-900 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                                                            {_ele?.name?.en}
                                                        </h4>
                                                        <p className="text-sm text-gray-500 dark:text-gray-400">Play now</p>
                                                    </div>
                                                    <svg className="w-5 h-5 text-gray-400 group-hover:text-orange-500 transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Games Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-4">
                        {Data.games && Data.games?.slice(4, 28)?.map((_ele, i) => {
                            const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                            return (
                                <GameCard key={`game-${i}`} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
                            );
                        })}
                        {Data.games && Data.games.length === 0 && (
                            <div className="col-span-12 lg:col-span-12 rounded-lg bg-white w-full h-40 flex justify-center items-center my-4">
                                <h2 className='text-[28px] font-bold'>
                                    No games found.
                                </h2>
                            </div>
                        )}
                    </div>
                </div>

                {/* Inline Ad */}
                <div className="my-8 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700">
                    <div className="text-center mb-4">
                        <span className="text-base text-gray-500 dark:text-gray-400 font-medium">Advertisement</span>
                    </div>
                    <div className='flex justify-center'>
                        <div className='hidden xl:block'>
                            <AdCMP adSize='728x90' dataAdSlot="4229378215" />
                        </div>
                        <div className='hidden md:block xl:hidden'>
                            <AdCMP adSize='468x60' dataAdSlot="4229378215" />
                        </div>
                        <div className='block md:hidden'>
                            <AdCMP adSize='320x50' dataAdSlot="4229378215" />
                        </div>
                    </div>
                </div>

                {/* Premium Games Section */}
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/10 dark:to-pink-900/10 rounded-2xl p-6 border border-purple-200 dark:border-purple-700">
                    <div className='flex justify-between items-center mb-6'>
                        <h2 className='text-black dark:text-white font-bold text-base sm:text-lg lg:text-xl flex items-center'>
                            <span className='text-xl sm:text-3xl lg:text-4xl mr-2 sm:mr-3'>🎯</span>
                            <span className='bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent'>Premium Games</span>
                        </h2>
                        <Link to="/category/all-games" className='group'>
                            <div className='bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-2 sm:px-5 sm:py-3 rounded-xl font-medium text-sm sm:text-lg hover:from-purple-400 hover:to-pink-400 transition-all duration-300 flex items-center'>
                                <span>View All</span>
                                <svg className='w-3 h-3 sm:w-4 sm:h-4 ml-1 sm:ml-2 transform group-hover:translate-x-1 transition-transform duration-300' fill='currentColor' viewBox='0 0 20 20'>
                                    <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                                </svg>
                            </div>
                        </Link>
                    </div>
                    <PremiumGames flag={12} />
                </div>

                {/* Side Ad */}
                <div className="my-8 grid grid-cols-1 lg:grid-cols-4 gap-6">
                    <div className="lg:col-span-3">
                        <div className='flex justify-between items-center mb-6'>
                            <h2 className='text-black dark:text-white font-bold text-lg sm:text-xl lg:text-2xl flex items-center'>
                                <span className='text-3xl sm:text-4xl mr-3'>🎮</span>
                                <span className='bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent'>Featured games</span>
                            </h2>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            {Data.games && Data.games?.slice(24, 36)?.map((_ele, i) => {
                                if (!_ele?.name?.en) return null;
                                const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                                return (
                                    <GameCard key={`featured-${i}`} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
                                );
                            })}
                        </div>
                    </div>
                    <div className="lg:col-span-1">
                        <div className="sticky top-20">
                            <div className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-4 border border-gray-200 dark:border-gray-700">
                                <div className="text-center mb-3">
                                    <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">Sponsored</span>
                                </div>
                                <AdCMP adSize='300x250' dataAdSlot="6784508920" />
                            </div>

                            <div className="mt-6 bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-900/10 dark:to-cyan-900/10 rounded-2xl p-4 border border-blue-200 dark:border-blue-700">
                                <h3 className="font-bold text-lg text-blue-900 dark:text-blue-100 mb-3 flex items-center">
                                    <span className="text-xl mr-2">✨</span>
                                    Quick Play
                                </h3>
                                <div className="space-y-3">
                                    {Data.games?.slice(0, 3)?.map((_ele, i) => {
                                        const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                                        return (
                                            <Link key={i} to={`/game/${GetSlug}`} className="flex items-center space-x-3 p-2 bg-white dark:bg-gray-800 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors duration-300 group">
                                                <img
                                                    src={_ele?.assets?.square}
                                                    alt={_ele?.name?.en}
                                                    className="w-8 h-8 object-cover rounded group-hover:scale-110 transition-transform duration-300"
                                                />
                                                <span className="text-sm font-medium text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300 truncate">
                                                    {_ele?.name?.en}
                                                </span>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Ad */}
                <div className="my-8 bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/10 dark:to-purple-900/10 rounded-2xl p-6 border border-indigo-200 dark:border-indigo-700">
                    <div className="text-center mb-4">
                        <span className="text-base text-indigo-600 dark:text-indigo-400 font-medium">Recommended for you</span>
                    </div>
                    <div className='flex justify-center'>
                        <div className='hidden xl:block'>
                            <AdCMP adSize='728x90' dataAdSlot="6784508920" />
                        </div>
                        <div className='hidden md:block xl:hidden'>
                            <AdCMP adSize='468x60' dataAdSlot="6784508920" />
                        </div>
                        <div className='block md:hidden'>
                            <AdCMP adSize='320x50' dataAdSlot="6784508920" />
                        </div>
                    </div>
                </div>

                {/* Games Blogs Section */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/10 dark:to-emerald-900/10 rounded-2xl p-6 border border-green-200 dark:border-green-700">
                    <div className='flex justify-between items-center mb-6'>
                        <h2 className='text-black dark:text-white font-bold text-lg sm:text-xl lg:text-2xl flex items-center'>
                            <span className='text-3xl sm:text-4xl mr-3'>📝</span>
                            <span className='bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent'>Gaming News & Blogs</span>
                        </h2>
                        <Link to="/blog" className='group'>
                            <div className='bg-gradient-to-r from-green-500 to-emerald-500 text-white px-5 py-3 rounded-xl font-medium text-lg hover:from-green-400 hover:to-emerald-400 transition-all duration-300 flex items-center'>
                                <span>Read More</span>
                                <svg className='w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300' fill='currentColor' viewBox='0 0 20 20'>
                                    <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                                </svg>
                            </div>
                        </Link>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
                        {gamesList && gamesList?.slice(30, 38)?.map((_ele, i) => {
                            if (!_ele?.name?.en) return null;
                            const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                            return (
                                <BlogCard
                                    key={`blog-${i}`}
                                    id={i}
                                    slug={GetSlug}
                                    name={_ele?.name?.en}
                                    banner={_ele?.assets?.cover}
                                    link={_ele?.URL}
                                    img={_ele?.assets?.square}
                                    _ele={_ele}
                                />
                            );
                        })}
                    </div>
                </div>

                {/* Final Ad Section */}
                <div className="my-8 bg-gradient-to-r from-pink-50 to-rose-50 dark:from-pink-900/10 dark:to-rose-900/10 rounded-2xl p-6 border border-pink-200 dark:border-pink-700">
                    <div className="text-center mb-4">
                        <span className="text-base text-pink-600 dark:text-pink-400 font-medium flex items-center justify-center">
                            <span className="mr-2">🎁</span>
                            Special Offers
                        </span>
                    </div>
                    <div className='flex justify-center'>
                        <div className='hidden xl:block'>
                            <AdCMP adSize='728x90' dataAdSlot="6200935433" />
                        </div>
                        <div className='hidden md:block xl:hidden'>
                            <AdCMP adSize='468x60' dataAdSlot="6200935433" />
                        </div>
                        <div className='block md:hidden'>
                            <AdCMP adSize='320x50' dataAdSlot="6200935433" />
                        </div>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="p-3 sm:p-4 sm:ml-56 mt-6 sm:mt-4">
                <div className="container mx-auto my-6 sm:my-10">
                    <div className="rounded-2xl bg-gradient-to-br from-white via-gray-50 to-purple-50 dark:from-gray-900 dark:via-black dark:to-purple-900/20 w-full flex items-center mb-6 sm:mb-7 lg:mb-12 xl:mb-16 p-4 sm:p-6 md:p-8 lg:p-12 shadow-2xl border border-gray-200/50 dark:border-gray-700/50 hover-glow">
                        <div>
                            <header className="text-base sm:text-lg lg:text-xl font-bold relative pl-4 sm:pl-6 mb-3 sm:mb-4 after:absolute after:w-1 after:h-full after:top-0 after:bg-gradient-to-b after:from-purple-500 after:to-pink-500 after:left-0 after:rounded-full">
                                <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">About VibeOfGames</span>
                            </header>

                            <div className="xl:pr-24 2xl:pr-36 flex flex-col gap-4 sm:gap-6 lg:gap-8">
                                <section className="p-6 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/10 dark:to-pink-900/10 rounded-xl border-l-4 border-purple-500">
                                    <h1 className="text-lg lg:text-xl font-bold capitalize mb-3 bg-gradient-to-r from-purple-700 to-pink-700 bg-clip-text text-transparent flex items-center">
                                        <svg className="w-8 h-8 mr-3 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z" clipRule="evenodd" />
                                        </svg>
                                        Discover Endless Fun with VibeOfGames
                                    </h1>
                                    <p className="leading-6 font-medium text-gray-700 dark:text-gray-300 text-sm">
                                        Welcome to <strong className="text-purple-600 dark:text-purple-400">VibeOfGames</strong> - your ultimate hub for{" "}
                                        <strong className="text-pink-600 dark:text-pink-400">free online games</strong>. Enjoy a diverse collection of{" "}
                                        <strong className="text-purple-600 dark:text-purple-400">action, puzzle, racing, multiplayer</strong>, and{" "}
                                        <strong className="text-pink-600 dark:text-pink-400">strategy games</strong>. No downloads, no logins - just instant gaming
                                        across <strong className="text-purple-600 dark:text-purple-400">desktop, mobile, and tablets</strong>!
                                    </p>
                                </section>

                                <section className="p-6 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/10 dark:to-indigo-900/10 rounded-xl border-l-4 border-blue-500">
                                    <h2 className="text-lg lg:text-xl font-bold capitalize mb-3 bg-gradient-to-r from-blue-700 to-indigo-700 bg-clip-text text-transparent flex items-center">
                                        <svg className="w-8 h-8 mr-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        Why Choose VibeOfGames?
                                    </h2>
                                    <p className="leading-6 font-medium text-gray-700 dark:text-gray-300 text-sm mb-3">
                                        VibeOfGames is built for ultimate gaming convenience:
                                    </p>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex items-center p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                                            <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-gray-700 dark:text-gray-300 font-medium">Thousands of free games updated regularly</span>
                                        </div>
                                        <div className="flex items-center p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                                            <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-gray-700 dark:text-gray-300 font-medium">Instant play - no downloads, no pop-ups</span>
                                        </div>
                                        <div className="flex items-center p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                                            <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-gray-700 dark:text-gray-300 font-medium">Optimized for desktop, mobile, and tablets</span>
                                        </div>
                                        <div className="flex items-center p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                                            <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-gray-700 dark:text-gray-300 font-medium">Single-player and multiplayer experiences</span>
                                        </div>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-base lg:text-lg font-bold capitalize mb-2 dark:text-gray-300">
                                        Our Popular Games
                                    </h2>
                                    <p className="leading-5 font-medium text-gray-700 dark:text-gray-300 text-xs">
                                        Play our most popular games now:
                                    </p>
                                    <ul className="list-disc pl-6 text-xs font-medium text-gray-700 dark:text-gray-300 leading-5">
                                        <li><Link to="/game/ludo-dash" className="text-blue-500 hover:underline">Ludo Dash</Link></li>
                                        <li><Link to="/game/fruit-chop" className="text-blue-500 hover:underline">Fruit Chop</Link></li>
                                        <li><Link to="/game/escape-run" className="text-blue-500 hover:underline">Escape Run</Link></li>
                                        <li><Link to="/game/save-your-pinky" className="text-blue-500 hover:underline">Save Your Pinky</Link></li>
                                        <li><Link to="/game/happy-kittens-puzzle" className="text-blue-500 hover:underline">Happy Kittens Puzzle</Link></li>
                                    </ul>
                                </section>

                                <section>
                                    <h2 className="text-base lg:text-lg font-bold capitalize mb-2 dark:text-gray-300">
                                        Explore Game Categories
                                    </h2>
                                    <p className="leading-5 font-medium text-gray-700 dark:text-gray-300 text-xs">
                                        Find the perfect game in these categories:
                                    </p>
                                    <ul className="list-disc pl-6 text-xs font-medium text-gray-700 dark:text-gray-300 leading-5">
                                        <li>Action & Adventure</li>
                                        <li>Puzzle & Brain Teasers</li>
                                        <li>Racing & Sports</li>
                                        <li>Classic & Retro Arcade</li>
                                        <li>Multiplayer Challenges</li>
                                    </ul>
                                </section>

                                <section>
                                    <h2 className="text-base lg:text-lg font-bold capitalize mb-2 dark:text-gray-300">
                                        Join Our Gaming Community
                                    </h2>
                                    <p className="leading-5 font-medium text-gray-700 dark:text-gray-300 text-xs">
                                        Become part of the <strong>VibeOfGames</strong> community! Compete, share, and
                                        explore new games daily.
                                    </p>
                                </section>

                                <section>
                                    <h2 className="text-base lg:text-lg font-bold capitalize mb-2 dark:text-gray-300">
                                        Play Now – 100% Free & Unlimited
                                    </h2>
                                    <p className="leading-5 font-medium text-gray-700 dark:text-gray-300 text-xs">
                                        Experience endless fun with **VibeOfGames**-your go-to **free online gaming** platform!
                                    </p>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Home;